<template>
	<li :class="classes" :data-commentid="event.id" :id="`comment-${event.id}`">
		<div class="comment__inner">
			<i :class="`event__icon ${icon}`"></i>
	
			<div class="event__meta">
				<span :title="fullDatetimeOutput" class="event__date">{{commentDateOutput}} ({{fromNowDateOutput}})</span>
	
				<span class="event__author">{{event.author}}</span>
			</div><!-- /.event__meta -->
	
			<div class="event__entry" v-html="title"></div>
		</div>
	</li>
</template>

<script>
import { commentDate, fromNow, fullDatetime } from '../filters';

export default {
	name: 'event',

	props: {
		event: {
			required: true,
		},
	},

	data() {
		return {
			rightNow: (new Date()).getTime()
		};
	},

	computed: {
		/**
		 * Element's classes.
		 *
		 * @return {Array}
		 */
		classes() {
			const eventType = this.event.comment_type.replace('^event_', '');

			return [
				'comment',
				'event',
				`event--${eventType}`
			];
		},

		fromNowDateOutput() {
			return fromNow(this.event.added_on, this.rightNow );
		},

		commentDateOutput() {
			return commentDate(this.event.added_on);
		},

		fullDatetimeOutput() {
			return fullDatetime(this.event.added_on)
		},

		/**
		 * Get event title based on event's type.
		 *
		 * @return {String}
		 */
		title() {
			switch (this.event.comment_type) {
				case 'event_project_snoozed':
					return 'Project snoozed';
				case 'event_reminder_added':
					return `Reminder about "${this.event.what}" added`;
				case 'event_reminder_sent':
					return `Reminder "${this.event.what}" sent`;
				case 'event_quote_posted':
					return `<a href="/quote/${this.event.comment}" target="_blank">Quote</a> posted`;
				case 'event_quote_accepted':
					return `<a href="/quote/${this.event.comment}" target="_blank">Quote</a> accepted`;
				case 'event_quote_voided':
					return `<a href="/quote/${this.event.comment}" target="_blank">Quote</a> voided`;
				case 'event_client_added':
					return 'Added a client';
				case 'event_manager_added':
					return 'Added a manager';
				case 'event_client_removed':
					return 'Removed a client';
				case 'event_manager_removed':
					return 'Removed a manager';
				case 'event_title_changed':
					return 'Changed the title';
				case 'event_status_changed':
					return `Changed the status to "${this.event.comment}"`;
				case 'event_charge_added':
					return 'Added a charge';
				case 'event_charge_updated':
					return 'Updated a charge';
				case 'event_charge_deleted':
					return 'Deleted a charge';
				case 'event_note_added':
					return 'Added a note';
				case 'event_repo_added':
					return 'Added a code repository';
				default:
					return 'Unknown Event';
			}
		},

		/**
		 * Get event icon based on event's type.
		 *
		 * @return {String}
		 */
		icon() {
			switch (this.event.comment_type) {
				case 'event_project_snoozed':
					return 'icon ico-archive';
				case 'event_reminder_added':
					return 'icon icon-bell-off';
				case 'event_reminder_sent':
					return 'icon icon-bell';
				case 'event_quote_posted':
					return 'icon icon-list-alt';
				case 'event_quote_accepted':
					return 'icon icon-check-square';
				case 'event_quote_voided':
					return 'icon icon-lock';
				case 'event_client_added':
				case 'event_manager_added':
					return 'icon icon-user-plus';
				case 'event_client_removed':
				case 'event_manager_removed':
					return 'icon icon-user-x';
				case 'event_title_changed':
					return 'icon icon-type';
				case 'event_status_changed':
					return 'icon icon-refresh-cw';
				case 'event_charge_added':
				case 'event_charge_updated':
				case 'event_charge_deleted':
					return 'icon icon-dollar-sign';
				case 'event_note_added':
					return 'icon icon-internal-note';
				case 'event_repo_added':
					return 'icon icon-github';
				default:
					return 'icon icon-flag';
			}
		},
	},

	mounted() {
		this.setUpdateCurrentTimeInterval();
	},

	methods: {
		/**
		 * Set update current time interval.
		 *
		 * @return {void}
		 */
		setUpdateCurrentTimeInterval() {
			setInterval(() => {
				this.rightNow = (new Date()).getTime();
			}, 30 * 1000);
		}
	}
}
</script>
